import React from "react";

const NetworkContext = React.createContext({isOffline:false});

export default NetworkContext;
